/**
 * Navigation menu controller. The header's [data-nav-toggle] button opens and
 * closes a full-screen panel by toggling `nav-menu-open` on <html> (the panel
 * slide + overlay fade are pure CSS in critical.css). Closes on the overlay or
 * panel [data-nav-close] buttons, Escape, and when a reservation trigger inside
 * the menu is clicked (the reservation modal then takes over). Nav links are
 * real links, so navigating reloads the page and resets the menu.
 *
 * Handlers are delegated on document so the controls keep working even after
 * the nav section's DOM is re-rendered (Shopify theme editor / `theme dev` hot
 * reload), which would drop listeners bound directly to the nodes.
 */
(function () {
  if (window.__navMenuInit) return;
  window.__navMenuInit = true;

  var OPEN_CLASS = 'nav-menu-open';
  var html = document.documentElement;

  function isOpen() {
    return html.classList.contains(OPEN_CLASS);
  }

  function setOpen(open) {
    html.classList.toggle(OPEN_CLASS, open);

    var toggle = document.querySelector('[data-nav-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }

    var root = document.querySelector('[data-nav-root]');
    if (root) {
      var panels = root.querySelectorAll('.nav-menu-left, .nav-menu');
      for (var i = 0; i < panels.length; i++) {
        panels[i].setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      var overlay = root.querySelector('.nav-menu-overlay');
      if (overlay) overlay.tabIndex = open ? 0 : -1;
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-nav-toggle]')) {
      setOpen(!isOpen());
      return;
    }

    if (target.closest('[data-nav-close]')) {
      setOpen(false);
      return;
    }

    // Opening the reservation modal from inside the menu should close the menu.
    var resTrigger = target.closest('[data-reservation-open]');
    if (resTrigger && resTrigger.closest('[data-nav-root]')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) setOpen(false);
  });
})();
